import React, { useEffect, useState } from "react";

import { ExclamationCircleOutlined } from "@ant-design/icons";
import Edit_icon from "../../../assets/images/icons/edit_icon.svg";
import AdminToolsService from "../../../services/admin-tools.service";
import { NotificationManager } from "react-notifications";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Modal, Table, Tooltip } from "antd";

const { confirm } = Modal;

const ClientDataMapping = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [clientDataMappingList, setClientDataMapList] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(0);
  const [sortType, setSortType] = useState("asc");
  const [sortColumnName, setSortColumnName] = useState("dealerId");

  useEffect(() => {
    handleGetClientDataMappingList(pageNo, pageSize, "dealerId", "asc");
  }, []);

  function showConfirm(id) {
    confirm({
      title: (
        <Tooltip title={t("Set Default Mapping")}>
          {t("Set Default Mapping")}
        </Tooltip>
      ),
      ellipsis: true,
      icon: <ExclamationCircleOutlined />,
      content: t(
        "Are you Sure By Submit Existing Mapping replace with Default mapping. ?"
      ),
      onOk() {
        handleSetDefaultMapping(id);
      },
      onCancel() {},
      okText: t("OK"),
      cancelText: t("Cancel"),
    });
  }
  const handleTableASCDES = (pagination, filters, sorter) => {
    var tableBody = document.querySelector(".clientDataMapTable .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    var type = "";
    var column = "";
    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else {
      type = "ASC";
      column = "dealerId";
      setSortColumnName(column);
      setSortType(type);
    }
    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);
    handleGetClientDataMappingList(
      pagination.current,
      pagination.pageSize,
      column,
      type
    );
  };

  const handleGetClientDataMappingList = (
    pageNo,
    pageSize,
    sortColumnName,
    sortOrder
  ) => {
    let inputData = {
      pageNumber: pageNo ? pageNo : 1,
      pageSize: pageSize ? pageSize : 15,
      sortOrderCol: sortColumnName || "dealerId",
      sortOrderType: sortOrder || "ASC",
    };
    setLoading(true);
    AdminToolsService.GetClientDataMappingList(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        setLoading(false);
        if (message === "Success") {
          setClientDataMapList(responseData.client_dataMapListResponse);
          setTotalCount(responseData.totalRecord);
        } else {
          setClientDataMapList([]);
          setTotalCount(0);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleSetDefaultMapping = (id) => {
    setLoading(true);
    let inputData = {
      dealerID: id,
    };
    AdminToolsService.SetDefaultMapping(inputData)
      .then((response) => {
        var message = response.data.message;
        setLoading(false);
        if (message === "Success") {
          handleGetClientDataMappingList(
            pageNo,
            pageSize,
            sortColumnName,
            sortType
          );
          NotificationManager.success(
            t("Defualt Mapping Created Successfully.")
          );
        } else {
          NotificationManager.error(t("Not Set Defualt Mapping."));
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <React.Fragment>
      <div className="clientdata_section">
        <div className="form__fields">
          <div className="row">
            <div className="col-lg-12">
              <h4 className="workarea__heading mt-0 mb-0">
                {t("Client Data Maps")}
              </h4>
            </div>

            <div className="col-lg-12 mt-4">
              <div className="clientdata_tbldiv clientDataMapTable">
                <Table
                  className="table-responsive"
                  scroll={{ y: "calc(100vh - 340px)" }}
                  loading={loading}
                  columns={[
                    {
                      title: (
                        <Tooltip title={t("Dealer ID")}>
                          {t("Dealer ID")}
                        </Tooltip>
                      ),
                      showSorterTooltip: false,
                      ellipsis: true,
                      dataIndex: "dealerID",
                      sorter: (a, b) => a.dealerID - b.dealerID,
                    },
                    {
                      title: (
                        <Tooltip title={t("Dealer Company")}>
                          {t("Dealer Company")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      showSorterTooltip: false,
                      dataIndex: "dealerCompany",
                      sorter: (a, b) =>
                        a.dealerCompany.localeCompare(b.dealerCompany),
                    },
                    {
                      title: (
                        <Tooltip title={t("Website Address")}>
                          {t("Website Address")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      showSorterTooltip: false,
                      dataIndex: "websiteAddress",
                    },
                    {
                      title: (
                        <Tooltip title={t("Upload")}>{t("Upload")}</Tooltip>
                      ),
                      ellipsis: true,
                      showSorterTooltip: false,
                      dataIndex: "upload",
                      render: (row, item) => {
                        return (
                          <React.Fragment>
                            <div className="action__btns">
                              <div className="image__block">
                                <Link
                                  to={"/uploadProductFile"}
                                  state={{
                                    dealerData: item,
                                    key: "ClientDataMapping",
                                  }}
                                >
                                  <img src={Edit_icon} alt="" />
                                </Link>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      },
                    },
                    {
                      title: (
                        <Tooltip title={t("InBound Data Map")}>
                          {t("InBound Data Map")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      showSorterTooltip: false,
                      dataIndex: "inbound_datamap",
                      render: (row, item) => {
                        return (
                          <React.Fragment>
                            <div className="action__btns">
                              <div className="image__block">
                                <Link
                                  to={"/adminDataMapping"}
                                  state={{ key: item.dealerID, columnID: 14 }}
                                >
                                  <img src={Edit_icon} alt="" />
                                </Link>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      },
                    },
                    {
                      title: (
                        <Tooltip title={t("Outgoing Data Map")}>
                          {t("Outgoing Data Map")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      showSorterTooltip: false,
                      dataIndex: "outgoing_datamap",
                      render: (row, item) => {
                        return (
                          <React.Fragment>
                            <div className="action__btns">
                              <div className="image__block">
                                <Link
                                  to={"/outGoingDataMap"}
                                  state={{ dealerID: item.dealerID }}
                                >
                                  <img src={Edit_icon} alt="" />
                                </Link>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      },
                    },
                    {
                      title: (
                        <Tooltip title={t("OutBound Sync")}>
                          {t("OutBound Sync")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      showSorterTooltip: false,
                      dataIndex: "outbound_sync",
                      render: (row, item) => {
                        return (
                          <React.Fragment>
                            <div className="action__btns">
                              <div className="image__block">
                                <Link
                                  to={"/outBoundSync"}
                                  state={{ dealerID: item.dealerID }}
                                >
                                  <img src={Edit_icon} alt="" />
                                </Link>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      },
                    },
                    {
                      title: (
                        <Tooltip title={t("Set Default Mapping")}>
                          {t("Set Default Mapping")}
                        </Tooltip>
                      ),
                      showSorterTooltip: false,
                      ellipsis: true,
                      dataIndex: "setdefault_mapping",
                      render: (row, item) => {
                        return (
                          <React.Fragment>
                            <Button
                              className="primary-btn"
                              onClick={(e) => {
                                showConfirm(item.dealerID);
                              }}
                            >
                              {t("Submit")}
                            </Button>
                          </React.Fragment>
                        );
                      },
                    },
                  ]}
                  onChange={(pagination, filters, sorters) => {
                    var tableBody = document.querySelector(".clientDataMapTable .ant-table-body");
                    if (tableBody) tableBody.scrollTop = 0;
                    handleTableASCDES(pagination, filters, sorters);
                  }}
                  dataSource={clientDataMappingList}
                  pagination={{
                    size: "small",
                    total: totalCount,
                    current: pageNo,
                    pageSize: pageSize,
                    pageSizeOptions: [10, 15, 20, 50, 100],
                    responsive: true,
                    showSizeChanger: true,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ClientDataMapping;
